import { useLocation } from 'react-router-dom'

export function useBreadcrumb() {
  const location = useLocation()
  
  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean)
    const breadcrumbItems = []
    
    // Always start with Dashboard
    breadcrumbItems.push({
      label: 'Dashboard',
      href: '/dashboard',
      isActive: location.pathname === '/dashboard'
    })
    
    // Add other segments
    const segmentMap: Record<string, string> = {
      'users': 'Users',
      'orgs': 'Organizations', 
      'tokens': 'Tokens',
      'agents': 'Agents',
      'audit': 'Audit Logs'
    }
    
    pathSegments.forEach((segment, index) => {
      if (segment !== 'dashboard' && segmentMap[segment]) {
        const href = '/' + pathSegments.slice(0, index + 1).join('/')
        breadcrumbItems.push({
          label: segmentMap[segment],
          href,
          isActive: index === pathSegments.length - 1
        })
      }
    })
    
    return breadcrumbItems
  }
  
  return {
    items: getBreadcrumbItems()
  }
}
